module.exports = __webpack_public_path__ + "static/img/GR.d91b332a.svg";